import { render, staticRenderFns } from "./AddPlacementComponentModal.vue?vue&type=template&id=0b53977f&"
import script from "./AddPlacementComponentModal.vue?vue&type=script&lang=js&"
export * from "./AddPlacementComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports